import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-page-not-found" }

import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'QPageNotFoundView',
  setup(__props) {

const router = useRouter()

function back() {
  router.back()
}

return (_ctx: any,_cache: any) => {
  const _component_AButton = _resolveComponent("AButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "q-page-not-found__header" }, " Такой страницы не существует ", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "q-page-not-found__error" }, " 404 ", -1)),
    _createVNode(_component_AButton, {
      type: "link",
      onClick: back
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" Вернуться туда где всё работало ")
      ])),
      _: 1,
      __: [0]
    })
  ]))
}
}

})